import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import type * as Types from '../../codegen/types.js';
import { GiftCardVariantsFragmentDoc, ProductVariantsFragmentDoc } from '../fragment.generated';

const defaultOptions = {} as const;
export type GetVariantsQueryVariables = Types.Exact<{
  input: Types.ProductInput;
}>;

export type GetVariantsQuery = {
  __typename?: 'Query';
  product?:
    | {
        __typename: 'GiftCardProduct';
        slug?: string | null;
        giftCardVariants: Array<{
          __typename?: 'GiftCardVariant';
          imageUrls: Array<string>;
          occasion?: string | null;
          priceDenomination?: string | null;
          sku: string;
          price: Array<{
            __typename?: 'Price';
            lastOfferedAtDate?: string | null;
            fromDate?: string | null;
            toDate?: string | null;
            actualPrice: {
              __typename?: 'CentPrecisionMoney';
              centAmount: number;
              currencyCode: string;
              fractionDigits: number;
              type: string;
            };
            thenPrice?: {
              __typename?: 'CentPrecisionMoney';
              centAmount: number;
              currencyCode: string;
              fractionDigits: number;
              type: string;
            } | null;
            wasPrice?: {
              __typename?: 'CentPrecisionMoney';
              centAmount: number;
              fractionDigits: number;
              type: string;
              currencyCode: string;
            } | null;
          }>;
        }>;
      }
    | {
        __typename: 'Product';
        slug?: string | null;
        variants: Array<{
          __typename?: 'Variant';
          backInStockNotificationsEnabled?: boolean | null;
          fit?: string | null;
          globalFit?: string | null;
          globalSize?: string | null;
          fitLabel?: string | null;
          size?: string | null;
          sku: string;
          badges?: Array<{ __typename?: 'ProductBadge'; code: string; type?: string | null } | null> | null;
          badgesV2?: {
            __typename?: 'ProductBadgeV2';
            cacheTTL?: number | null;
            textual?: {
              __typename?: 'ProductBadgeTextual';
              url?: string | null;
              textColor?: string | null;
              text?: string | null;
              code?: string | null;
              backgroundColor?: string | null;
            } | null;
            image?: {
              __typename?: 'ProductBadgeImage';
              src?: string | null;
              code?: string | null;
              alt?: string | null;
              url?: string | null;
            } | null;
          } | null;
          stock: { __typename?: 'Stock'; availableQuantity: number; status: Types.StockStatus };
          price: Array<{
            __typename?: 'Price';
            lastOfferedAtDate?: string | null;
            fromDate?: string | null;
            toDate?: string | null;
            actualPrice: {
              __typename?: 'CentPrecisionMoney';
              centAmount: number;
              currencyCode: string;
              fractionDigits: number;
              type: string;
            };
            thenPrice?: {
              __typename?: 'CentPrecisionMoney';
              centAmount: number;
              currencyCode: string;
              fractionDigits: number;
              type: string;
            } | null;
            wasPrice?: {
              __typename?: 'CentPrecisionMoney';
              centAmount: number;
              fractionDigits: number;
              type: string;
              currencyCode: string;
            } | null;
          }>;
        }>;
      }
    | null;
};

export const GetVariantsDocument = gql`
  query getVariants($input: ProductInput!) {
    product(input: $input) {
      __typename
      ... on GiftCardProduct {
        slug
        ...GiftCardVariants
      }
      ... on Product {
        slug
        ...ProductVariants
      }
    }
  }
  ${GiftCardVariantsFragmentDoc}
  ${ProductVariantsFragmentDoc}
`;

/**
 * __useGetVariantsQuery__
 *
 * To run a query within a React component, call `useGetVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVariantsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetVariantsQuery(baseOptions: Apollo.QueryHookOptions<GetVariantsQuery, GetVariantsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetVariantsQuery, GetVariantsQueryVariables>(GetVariantsDocument, options);
}
export function useGetVariantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetVariantsQuery, GetVariantsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetVariantsQuery, GetVariantsQueryVariables>(GetVariantsDocument, options);
}
export type GetVariantsQueryHookResult = ReturnType<typeof useGetVariantsQuery>;
export type GetVariantsLazyQueryHookResult = ReturnType<typeof useGetVariantsLazyQuery>;
export type GetVariantsQueryResult = Apollo.QueryResult<GetVariantsQuery, GetVariantsQueryVariables>;
